
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import PrivacyPolicy from './components/PrivacyPolicy';
import PrivacyPolicy3DPrintForge from './components/PrivacyPolicy3DPrintForge';
import PrivacyPolicyVamosly from './components/PrivacyPolicyVamosly';
import AccountDeletion from './components/AccountDeletion';
import AccountDeletionRideRoster from './components/AccountDeletionRideRoster';
import AccountDeletionVamosly from './components/AccountDeletionVamosly';
import TermsAndConditions from './components/TermsAndConditions';
import TermsAndConditions3DPrintForge from './components/TermsAndConditions3DPrintForge';
import TermsAndConditionsVamosly from './components/TermsAndConditionsVamosly';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const path = window.location.pathname;

let content = <App />;

if (path === '/privacy/teemates-tours') {
  content = (
    <PrivacyPolicy 
      onClose={() => {
        window.location.href = '/';
      }} 
    />
  );
} else if (path === '/delete-account/teemates-tours') {
  content = (
    <AccountDeletion 
      appName="TeeMates Tours"
      onClose={() => {
        window.location.href = '/';
      }} 
    />
  );
} else if (path === '/delete-account/ride-roster') {
  content = (
    <AccountDeletionRideRoster 
      appName="Ride Roster"
      onClose={() => {
        window.location.href = '/';
      }} 
    />
  );
} else if (path === '/terms/ride-roster') {
  content = (
    <TermsAndConditions 
      appName="Ride Roster"
      onClose={() => {
        window.location.href = '/';
      }} 
    />
  );
} else if (path === '/privacy/3d-print-forge') {
  content = (
    <PrivacyPolicy3DPrintForge 
      appName="3D Print Forge"
      onClose={() => {
        window.location.href = '/';
      }} 
    />
  );
} else if (path === '/terms/3d-print-forge') {
  content = (
    <TermsAndConditions3DPrintForge 
      appName="3D Print Forge"
      onClose={() => {
        window.location.href = '/';
      }} 
    />
  );
} else if (path === '/privacy/vamosly') {
  content = (
    <PrivacyPolicyVamosly 
      appName="Vamosly"
      onClose={() => {
        window.location.href = '/';
      }} 
    />
  );
} else if (path === '/delete-account/vamosly') {
  content = (
    <AccountDeletionVamosly 
      appName="Vamosly"
      onClose={() => {
        window.location.href = '/';
      }} 
    />
  );
} else if (path === '/terms/vamosly') {
  content = (
    <TermsAndConditionsVamosly 
      appName="Vamosly"
      onClose={() => {
        window.location.href = '/';
      }} 
    />
  );
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    {content}
  </React.StrictMode>
);
